<template>
  <el-dialog
    custom-class="real-dialog"
    title="营收数据统计字段排序"
    :visible="dialogVisible"
    width="500px"
    top="20px"
    @close="handleClose"
    center
    append-to-body
  >
    <draggable v-model="noticeArray">
      <transition-group name="fade">
        <div v-for="element in noticeArray" :key="element.Value" class="move">
          {{element.Key}}
        </div>
      </transition-group>
    </draggable>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClick">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import draggable from "vuedraggable"
import showdialog from "@/minxs/showdialog";
import { sortSentryStatField } from "@/api/module/park";

export default {
  components: {
    draggable
  },
  props: {
    sortSentryStatFields: {
      type: [Array, String],
      default: undefined,
    }
  },
  mixins: [showdialog],
  data() {
    return {
      noticeArray: [],
    };
  },
  computed: {
  },
  watch: {
  },
  mounted() {
    this.$nextTick(() => {
      if (this.sortSentryStatFields.length > 0) {
        this.noticeArray = this.sortSentryStatFields
      }
    });
  },
  methods: {
    async handleClick(){
      let arr = this.noticeArray.map(v => {
        return v.Value
      });
      let res = await sortSentryStatField({
        fields: arr.join(','),
        sentryId: Number(sessionStorage.getItem("sentryId")),
      });
      if (res.state === "success") {
        this.$store.dispatch("SETNoticeSortStr", JSON.stringify(arr));
        this.handleClose();
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .move{
    cursor: move;
    line-height: 3;
    color: #000;
    font-size: 14px;
    text-align: center;
    margin-bottom: 10px;
    background: rgba(94, 127, 236, 0.1);
    /*border: 1px solid  #999;*/

  }
</style>
